import type { MaltaFullTimeNoticeKey } from "@/src/constants/AdmissionOffice/Malta/maltaFullTimeAdmissionConfig";

export type MaltaDistanceFeeLineKey = "tuitionFee" | "admissionFee" | "otherExpenses" | "certificationEqualization";

export type MaltaDistanceFeeVisibility = Record<MaltaDistanceFeeLineKey, boolean>;

export const MALTA_DISTANCE_FEE_LINE_ORDER: MaltaDistanceFeeLineKey[] = [
  "tuitionFee",
  "admissionFee",
  "otherExpenses",
  "certificationEqualization",
];

export const MALTA_DISTANCE_FEE_LINE_SUFFIXES: Record<MaltaDistanceFeeLineKey, string> = {
  tuitionFee: " EUR (per year)",
  admissionFee: " EUR one-time payment",
  otherExpenses: " EUR first year only",
  certificationEqualization: " EUR (first year only)",
};

export const MALTA_DISTANCE_FEE_LINE_LABELS: Record<MaltaDistanceFeeLineKey, string> = {
  tuitionFee: "Tuition Fee",
  admissionFee: "Admission Fee",
  otherExpenses: "Other Expenses (Administrative Fee, Registration Fee, etc.)",
  certificationEqualization: "Certification and Equalization of all documents",
};

export const formatMaltaDistanceFeeLineDisplay = (key: MaltaDistanceFeeLineKey, numericValue?: string) => {
  const trimmed = numericValue?.trim();
  if (!trimmed) return "";
  return `${trimmed}${MALTA_DISTANCE_FEE_LINE_SUFFIXES[key]}`;
};

export const MALTA_DISTANCE_STATIC_ADMISSION_PARAGRAPH =
  "This Admission Letter confirms your eligibility to study in International European University. To continue the admission process and to enroll to the university, you need to cover the complete first year fee. After the payment is received you will be officially accepted to the university and provided with your personal Student\u2019s Office. There you will have an access to your personalized curriculum, all the educational materials, lectures, textbooks, etc. The classes will be provided according to your schedule and curriculum.";

export type MaltaDistanceNoticeKey = MaltaFullTimeNoticeKey;
